import { useCallback, useMemo } from "react";
import { roofTypeIdsAtom } from "./RoofTypeFilter";
import { useAtom } from "jotai";
import { customerIdAtom } from "./CustomerFilter";
import { residenceCategoryIdsAtom } from "./ResidenceCategoryFilter";
import { Button } from "@chakra-ui/react";

export function ResetFiltersButton() {
  const [customerId, setCustomerId] = useAtom(customerIdAtom);
  const [residenceCategoryIds, setResidenceCategoryIds] = useAtom(
    residenceCategoryIdsAtom
  );
  const [roofTypeIds, setRoofTypeIds] = useAtom(roofTypeIdsAtom);

  const anyFilterApplied = useMemo(
    () =>
      residenceCategoryIds.length > 0 ||
      roofTypeIds.length > 0 ||
      customerId !== undefined,
    [residenceCategoryIds, roofTypeIds, customerId]
  );

  const handleReset = useCallback(() => {
    setCustomerId(undefined);
    setResidenceCategoryIds([]);
    setRoofTypeIds([]);
  }, [setCustomerId, setResidenceCategoryIds, setRoofTypeIds]);

  if (!anyFilterApplied) return null;

  return (
    <Button onClick={handleReset} size="xs" variant="link">
      Reset alle filters
    </Button>
  );
}
